<template>
  <cube-tab-bar
    wx:model="{{selectedLabelSlotsOnly}}"
    wx:model-prop="value"
    bindclick="clickHandler"
    bindchange="changeHandler"
    custom-content
    tabs="{{tabs}}"
  >
    <cube-tab
      class="cube-tab"
      wx:for="{{tabs}}"
      wx:key="label"
      label="{{item.label}}"
      value="{{item.value}}"
      custom-content
      custom-icon
    >
      <cube-icon type="{{item.icon}}"/>
      <!-- use en empty tag to replace default slot -->
      <text></text>
    </cube-tab>
  </cube-tab-bar>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    data: {
      selectedLabelSlotsOnly: 'Star',
      tabs: [{
        label: 'Home',
        value: 'Home',
        icon: 'home'
      }, {
        label: 'Like',
        value: 'Like',
        icon: 'like'
      }, {
        label: 'User',
        value: 'User',
        icon: 'user'
      }, {
        label: 'Star',
        value: 'Star',
        icon: 'star'
      }]
    },
    methods: {
      clickHandler (label) {
        console.log('tab was clicked', label)
      },
      changeHandler (label) {
        console.log('value has changed, now is', label)
      }
    }
  })
</script>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "usingComponents": {
      "cube-tab-bar": "@mpxjs/mpx-cube-ui/src/components/tab-bar/index.mpx",
      "cube-tab": "@mpxjs/mpx-cube-ui/src/components/tab-bar/tab.mpx",
      "cube-icon": "@mpxjs/mpx-cube-ui/src/components/icon/index.mpx"
    }
  }
</script>
